import {
  DataTable,
  FormDateRangePicker,
  FormSelect,
  Heading,
  Loader,
} from "@/components";
import useListing from "./useListing";
import { Button } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { BILLING_RUN_DATE, JOB_RUN_STATUS, jobStatus } from "../consts";

const Listing = () => {
  const {
    columns,
    globalFilter,
    setGlobalFilter,
    onRowClick,
    isDocLoading,
    documentList,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    isDocRefetching,
    form,
    onSubmit,
    onClear,
    communityDetail,
    isLoadingBillingCategory,
    sorting,
    setSorting,
  } = useListing();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title={`Billing History - ${communityDetail?.name}`} />
          {/* {isMobile && <Button className="px-2">+ Add Budget</Button>} */}
        </div>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-[10px] mt-[10px]">
              <FormSelect
                name={JOB_RUN_STATUS}
                control={form.control}
                label="Status"
                placeholder="Please select"
                error={errors[JOB_RUN_STATUS]?.message}
                options={jobStatus}
                className="bg-white"
              />
              <FormDateRangePicker
                name={BILLING_RUN_DATE}
                control={form.control}
                label="Run Date Range"
                placeholder="Please select"
                error={errors[BILLING_RUN_DATE]?.message}
              />
              <div className="flex items-center justify-end gap-2">
                <Button type="submit">Search</Button>
                <Button
                  variant="outline"
                  type="button"
                  onClick={onClear}
                  className="text-[12px]"
                >
                  Clear
                </Button>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>

      {/* Responsive Table */}
      {isDocLoading || isDocRefetching || isLoadingBillingCategory ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={documentList?.data || []}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(documentList?.total / pageSize)}
            totalRecords={documentList?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
        </>
      )}
    </div>
  );
};

export default Listing;
